export default __webpack_public_path__ + "static/media/cart-blue.03121472.svg";